/**
 * Returns the correct singular/plural NOUN for `count` — callers compose the
 * full phrase themselves, e.g. `` `${count} ${pluralize(count, 'item')}` ``.
 */
export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return count === 1 ? singular : plural
}
